<template>
  <div class="Media-Info Page">
    <div class="Page-Content Media-Info-Content">
    <h2>3 app logos and accounts</h2>
    <img src="@/assets/btn/Facebook.png" alt="">
    <img src="@/assets/btn/Instagram.jpg" alt="">
    <img src="@/assets/btn/TikTok.jpg" alt="">
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      
    }
  },
  methods:{

  },
  mounted(){

  },
}
</script>

<style lang="less">


.Media-Info{
  .Media-Info-Content{
    width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  h2{
    margin-bottom: 10vh;
  }
  img{
    width: 50px;
    padding: 10px;
    border-radius: 25px;
  }
  }

}

</style>
